import * as yup from 'yup';

export const validationSchema = yup.object({
    brandName: yup
        .string()
        .required('Required'),
    description: yup.
        string().
        required("Requied"),
})

export const initialValues = {
    brandName: "",
    description:"",
    status: true,
}